export default "__VITE_ASSET__Dmk1mvvd__"